<template>
  <div>
    <div class="header-single header-projeto">
      <div class="container  h-100">
        <div class="row align-items-end  h-100">
          <div class="col-sm ">
            <h1 class="align-bottom">{{ $t('projetosInstitucional.titulo') }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-5">
      <div class="row mb-4">
        <div class="col-md-4 p-4">
          <p>{{ $t('projetosInstitucional.paragrafo1') }}</p>
        </div>
        <div class="col-md-4 p-4">
          <p>{{ $t('projetosInstitucional.paragrafo2_1') }}<a href="https://institutohorus.org.br/levantamento-nacional-de-especies-exoticas-invasoras/" target="_blank">{{ $t('projetosInstitucional.paragrafo2_2') }}</a>{{ $t('projetosInstitucional.paragrafo2_3') }} </p>
        </div>
        <div class="col-md-4 p-0">
          <div class="p-3 rounded-5 box-citacao">
            <p>{{ $t('projetosInstitucional.paragrafo3') }}</p>
            <p class="mb-0">
              <em>{{ $t('label.citacao_bd_new') }}</em><br/>
              <em>{{ $t('label.citacao_bd_new1') }}</em><br/>
              <em>{{ $t('label.citacao_bd_new2') }}</em>
            </p>
            </div>
        </div>
      </div>
      <ProjetosForm v-if="viewItem" :idItem="projeto.project_id" :viewItem="true" :byInstitucional="true"/>
      <Projetos v-else :withPageTitle="false" :withOrderBy="true" :byInstitucional="true" @actionByInstitucional="actionByInstitucional"/>
      <div class="row mb-2 mb-xl-3">
        <div class="col-auto ml-auto text-right mt-n1">
          <button v-if="viewItem" @click="viewItem=false" class="btn bt-filtrar mt-1 mb-2">
            {{ $t('label.exibirListagem') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'driver.js/dist/driver.min.css'
import Projetos from '../../admin/projetos/Projetos.vue'
import ProjetosForm from '../../admin/projetos/ProjetosForm.vue'
export default {
  name: 'ProjetosInstitucional',
  components: { Projetos, ProjetosForm },
  data () {
    return {
      driver: null,
      viewItem: false,
      projeto: {}
    }
  },
  methods: {
    actionByInstitucional: function (item) {
      this.projeto = item
      this.viewItem = true
    }
  },
  created () {
    this.viewItem = false
  }
}
</script>
